import { gsap } from 'gsap';
import gsapCore from 'gsap/gsap-core';
import Scrolltrigger from 'gsap/ScrollTrigger';
gsap.registerPlugin(Scrolltrigger);
gsap.config({ nullTargetWarn: false, });

let flg = true;
/*
$(document).on('click', '.menu-btn', function () {
  let $this = $(this);
  let $tar = $this.parent().next();
  $tar.stop().toggleClass('active');
  $this.find('.menu-trigger').stop().toggleClass('active');
  return false;
});
*/
$(document).on('click', '.menu-btn', function () {
  var $this = $(this);
  $this.find('.menu-trigger').stop().toggleClass('active');

  if (flg) {
    gsap.to('.main-nav', 0.5, {
      autoAlpha: 1
    });
    gsap.to('.sp-entry-btn', 0.5, {
      autoAlpha: 0
    });
    gsap.to('.sub-nav', 0.5, {
      autoAlpha: 0
    });
    flg = false;
  } else {

    gsap.to('.main-nav', 0.5, {
      autoAlpha: 0
    });
    gsap.to('.sp-entry-btn', 0.5, {
      autoAlpha: 1
    });
    gsap.to('.sub-nav', 0.5, {
      autoAlpha: 1
    });
    flg = true;
  }
  return false;
});

